"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'Party',
    props: {
        party: {
            type: Object,
            required: true,
        },
        isDominant: {
            type: Boolean,
        },
        isAvailable: {
            type: Boolean,
        },
    },
    methods: {
        partyNameToCss(party) {
            if (party === undefined) {
                console.warn('no party provided');
                return '';
            }
            return party.toLowerCase().split(' ').join('_');
        },
        getDominantClass() {
            return 'select-party-leader-spot' + (this.isDominant ? ' dominance-marker' : '');
        },
        getUnavailablePartyClass() {
            return this.isAvailable ? '' : ' unavailable-party';
        },
    },
});
